import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/landing/Header';
import Hero from './components/landing/Hero';
import Benefits from './components/landing/Benefits';
import Process from './components/landing/Process';
import FAQ from './components/landing/FAQ';
import Contact from './components/landing/Contact';
import Blog from './components/landing/Blog';
import Footer from './components/landing/Footer';
import BlogListPage from './pages/blog/BlogListPage';
import BlogPostPage from './pages/blog/BlogPostPage';
import BlogAdminPage from './pages/blog/BlogAdminPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './pages/admin/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Landing Page Component
const LandingPage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Process />
        <FAQ />
        <Contact />
        <Blog />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/blog" element={
              <ProtectedRoute>
                <BlogAdminPage />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
